import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById("root");
// Wipe the SEO-fallback content that the static HTML file pre-renders for
// crawlers before React mounts its own tree — prevents a flash of duplicated
// content.
const seoFallback = rootEl && rootEl.querySelector('#seo-fallback');
if (seoFallback) seoFallback.remove();
// Signal to CSS that React has taken over — hides any residual `.seo-fallback`
// (belt-and-braces if the removal above missed anything).
document.body.classList.add('app-booted');

const root = ReactDOM.createRoot(rootEl);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
